import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { Label } from "@/components/ui/label";
import {
  Select,
  SelectTrigger,
  SelectValue,
  SelectContent,
  SelectItem,
} from "@/components/ui/select";
import qr from "../assets/qr.png";
import { useForm, Controller } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { z } from "zod";
import { PayPalSubscribeButton } from "./PaypalImpulsa";
import yape from "../assets/yape.png";
import plin from "../assets/plin.png";
import lemon from "../assets/lemon.jpeg";
import mercadopago from "../assets/mercadopago.png";
import { Card } from "./ui/card";
const schema = z.object({
  metodo: z.enum(["billetera", "paypal", "mercadopago", "transferencia"]),
  period: z.enum(["mensual"]),
  plan: z.enum(["IMPULSO", "VISION"]),
});

export function ManualPaymentDialog() {
  const {
    control,
    watch,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: zodResolver(schema),
    defaultValues: {
      metodo: "",
      period: "mensual",
      plan: "IMPULSO",
    },
  });

  const metodo = watch("metodo");
  const plan = watch("plan");

  const onSubmit = (data) => {};

  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button className="w-full">Pagar</Button>
      </DialogTrigger>
      <DialogContent className="max-w-md max-h-[500px] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>Checkout</DialogTitle>
        </DialogHeader>

        <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
          {/* Método */}
          <div>
            {/* <Label className="mb-1 block">Método de pago</Label> */}
            <Controller
              control={control}
              name="metodo"
              render={({ field }) => (
                <RadioGroup
                  value={field.value}
                  onValueChange={field.onChange}
                  className="space-y-2"
                >
                  {[
                    ["billetera", "Lemon, Yape, Plin", "Paga con código QR"],
                    // ["paypal", "Paypal", "Paga con código QR"],
                    [
                      "mercadopago",
                      "Mercado Pago",
                      "Pago con tarjeta crédito, débito",
                    ],
                    // ["transferencia", "Transferencia", "Vía bancos"],
                  ].map(([value, label, hint]) => (
                    <Card className="px-3">
                      <div key={value} className="flex items-center space-x-2">
                        <RadioGroupItem value={value} id={value} />
                        <div>
                          <Label htmlFor={value} className="font-medium">
                            {label === "Lemon, Yape, Plin" && (
                              <>
                                <img width={30} src={lemon}></img>
                                <img width={30} src={yape}></img>
                                <img width={30} src={plin}></img>
                              </>
                            )}
                            {label === "Mercado Pago" && (
                              <>
                                <img width={30} src={mercadopago}></img>
                              </>
                            )}
                            {label}
                          </Label>
                          <div
                            htmlFor={value}
                            className="text-sm text-muted-foreground"
                          >
                            {hint}
                          </div>
                        </div>
                      </div>
                    </Card>
                  ))}
                </RadioGroup>
              )}
            />
          </div>

          {/* Periodo */}
          <div>
            <Label className="mb-1 block">Periodo</Label>
            <Controller
              control={control}
              name="period"
              render={({ field }) => (
                <Select value={field.value} onValueChange={field.onChange}>
                  <SelectTrigger className="w-full">
                    <SelectValue placeholder="Selecciona periodo" />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="mensual">Mensual</SelectItem>
                  </SelectContent>
                </Select>
              )}
            />
          </div>

          {/* Planes */}
          <div>
            <Label className="mb-1 block">Planes</Label>
            <Controller
              control={control}
              name="plan"
              render={({ field }) => (
                <RadioGroup value={field.value} onValueChange={field.onChange}>
                  <Card className="px-3">
                    <div className="flex items-center space-x-2">
                      <RadioGroupItem value="IMPULSO" id="IMPULSO" />
                      <Label htmlFor="IMPULSO" className="flex-1">
                        <div>
                          IMPULSO{" "}
                          <span className="text-muted-foreground block text-sm">
                            Si recién estás comenzando
                          </span>
                        </div>
                      </Label>
                      <span className="font-semibold">S/ 10</span>
                    </div>
                  </Card>
                  <Card className="px-3">
                    <div className="flex items-center space-x-2">
                      <RadioGroupItem value="VISION" id="VISION" />
                      <Label htmlFor="VISION" className="flex-1">
                        <div>
                          VISIÓN <br></br>
                          <span className="text-muted-foreground block text-sm">
                            Si tu cuenta personal está creciendo en automático
                          </span>
                        </div>
                      </Label>
                      <span className="font-semibold">S/ 15</span>
                    </div>
                  </Card>
                </RadioGroup>
              )}
            />
          </div>

          {/* Contenido condicional */}
          {metodo === "billetera" && (
            <div className="space-y-2">
              <div className="bg-[red] p-3 rounded-md text-sm">
                <span className="text-white">
                  Escanea este QR con tu App de{" "}
                  <strong>YAPE, PLIN, LEMON</strong> y deja una nota con tu{" "}
                </span>
                <code className="text-white font-bold">
                  Correo eletrónico - mes de pago
                </code>{" "}
                <span className="text-white">
                  en máximo 10 min habilitamos tu pago
                </span>
              </div>
              <div className="flex  justify-center flex-col items-center">
                <img
                  src={qr}
                  alt="Código QR"
                  className="w-60 h-60 border rounded"
                />
                <br />
                <Button
                  className="w-[200px]"
                  onClick={() => (window.location.href = "/gracias")}
                >
                  Ya pagúe
                </Button>
              </div>
            </div>
          )}

          {metodo === "mercadopago" && (
            <>
              {plan === "IMPULSO" ? (
                <Button
                  className="w-full"
                  onClick={() =>
                    window.open("https://mpago.la/18YMbaq", "_blank")
                  }
                  color="#3483fa"
                  style={{ backgroundColor: "#3483fa" }}
                >
                  <img
                    width="70"
                    src="https://mobile.mercadolibre.com/remote_resources/image/web-private-nav-mp-logo"
                  ></img>
                  Pagar S/10
                </Button>
              ) : (
                <Button
                  className="w-full"
                  onClick={() =>
                    window.open("https://mpago.la/2uSBgio", "_blank")
                  }
                  color="#3483fa"
                  style={{ backgroundColor: "#3483fa" }}
                >
                  <img
                    width="70"
                    src="https://mobile.mercadolibre.com/remote_resources/image/web-private-nav-mp-logo"
                  ></img>
                  Pagar S/15
                </Button>
              )}
              {/* <Button
                className="w-full"
                onClick={() =>
                  window.open(
                    "https://www.mercadopago.com.pe/subscriptions/checkout?preapproval_plan_id=2c93808497030fc701970fdd95d10427",
                    "_blank"
                  )
                }
                color="#3483fa"
                style={{ backgroundColor: "#3483fa" }}
              >
                <img
                  width="70"
                  src="https://mobile.mercadolibre.com/remote_resources/image/web-private-nav-mp-logo"
                ></img>
                Pagar
              </Button> */}
            </>
          )}
          {metodo === "transferencia" && (
            <ul className="text-sm space-y-1 text-muted-foreground">
              <li>BCP - 12345678901234</li>
              <li>BBVA - 98765432101234</li>
            </ul>
          )}
        </form>
      </DialogContent>
    </Dialog>
  );
}
